let root = document.documentElement;
var header = document.getElementById('header')
var rootfs = window.getComputedStyle(root).getPropertyValue('font-size');
var calcRem = header.clientHeight / parseFloat(rootfs)
console.log(header.clientHeight)
console.log(rootfs)
console.log("Set --fixed-header-spacing to around " + parseFloat( calcRem).toFixed(2) + "rem")
root.style.setProperty('--fixed-header-spacing', parseFloat( calcRem).toFixed(2) + 'rem')
